import { pdsTv } from '@purinanbm/pds-ui';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Chip from '../chip/Chip';
import ClearAll from './ClearAll';

type Props = {
  style?: React.CSSProperties;
  className?: string;
  activeFacets: FacetLink[];
  onFacetRemove: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ChipLabel: React.FC<{ activeFacet: FacetLink }> = ({ activeFacet }) => {
  if (activeFacet.values.verboseChip) {
    return (
      <span>
        <strong>{`${activeFacet.values.parentLabel}: `}</strong>
        {activeFacet.values.value}
      </span>
    );
  }
  return <span>{activeFacet.values.value}</span>;
};

const SearchActiveFacetList: React.FC<Props> = function ({
  activeFacets,
  onFacetRemove,
  className,
  ...props
}: Props) {
  const { t } = useTranslation();
  const chipListTv = pdsTv({
    base: 'pds-mb-0 pds-inline-flex pds-w-auto pds-max-w-full pds-flex-wrap pds-items-center pds-gap-4 pds-pl-5',
  });
  return (
    <ul {...props} className={chipListTv({ className })}>
      <AnimatePresence>
        {activeFacets.map(activeFacet => {
          if (activeFacet) {
            const facetAria = t('Remove "{{value}}" from active filters.', {
              value: activeFacet.values.verboseChip
                ? `${activeFacet.values.parentLabel}: ${activeFacet.values.value}`
                : activeFacet.values.value,
            });
            return (
              <motion.li
                key={`facet-${activeFacet.raw_value}`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Chip
                  aria-label={facetAria}
                  label={<ChipLabel activeFacet={activeFacet} />}
                  onClick={onFacetRemove as any}
                  onDelete={onFacetRemove as any}
                  data-url={activeFacet.url}
                />
              </motion.li>
            );
          }
          return null;
        })}
      </AnimatePresence>
      {activeFacets.length > 0 && (
        <li>
          <ClearAll onClick={onFacetRemove as any}>{t('Clear All')}</ClearAll>
        </li>
      )}
    </ul>
  );
};

export default SearchActiveFacetList;
